import { render } from 'preact';
import './index.css';
import { App } from './app';
import { init } from './sync/engine';
import { captureInviteFromUrl } from './lib/http';

// linkul personal de invitație (#invite=…) → salvat pe acest dispozitiv
captureInviteFromUrl();

// modul dev/teste: ?dev_user=email setează identitatea locală (serverul o acceptă DOAR cu AUTH_MODE=dev)
const devUser = new URLSearchParams(location.search).get('dev_user');
if (devUser) { localStorage.setItem('cc10_dev_user', devUser); history.replaceState(null, '', location.pathname); }

render(<App />, document.getElementById('app')!);
void init();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}
